import { StoryCategory, Assets } from './entities';
import { StoryObject } from './story';

export const findPrimaryImage = (assets?: Assets[]) => {
  if (Array.isArray(assets) && assets.length) {
    for (const asset of assets) {
      if (asset.type === 'image' && asset.primary && asset.attributes.filepath) {
        // ToDo: This is dumb. Get backend to to return full URL.
        return 'https://www.benzinga.com/' + asset.attributes.filepath;
      }
    }
  }

  return '';
};

export const deDuplicateArticles = () => {
  let newsExistingIDs: number[] = [];
  let duplicateCount = 0;
  const verifyDuplicateArticles = (newsList: any[], newPageList: any[], pageNo: number) => {
    if (pageNo === 0) {
      newsExistingIDs = Array.from(new Set(newPageList.map(news => news.id)));
      newsList = [...newPageList];
      duplicateCount = 0;
    } else {
      const newArticles: any[] = [];
      newPageList.forEach(item => {
        if (newsExistingIDs?.indexOf(item.id) === -1) {
          newsExistingIDs.push(item.id);
          newArticles.push(item);
        } else {
          duplicateCount += 1;
        }
      });
      newsList = newsList.concat(newArticles);
    }
    return { duplicateCount, newsList };
  };
  return verifyDuplicateArticles;
};

export const filterDuplicateArticles = (items: StoryObject[], additionalNodeIds: number[] = []): StoryObject[] => {
  const nodeIds: number[] = [];
  if (!Array.isArray(items)) return [];
  const filteredItems = items.filter(node => {
    if (!nodeIds.includes(node.id) && !additionalNodeIds.includes(node.id)) {
      nodeIds.push(node.id);
      return true;
    }
    return false;
  });
  return filteredItems;
};

export const nodeHasChannel = (node: StoryObject, channel: StoryCategory | string) => {
  if (!node?.channels) {
    return false;
  }
  const channel_name = typeof channel === 'string' ? channel : channel.name;
  let has_channel = false;
  node?.channels?.forEach((c: StoryCategory) => {
    const cn = c.name ? c.name : c;
    if (channel_name === cn) has_channel = true;
  });
  return has_channel;
};

export const getNodesForNewsChannel = (nodes: StoryObject[], channel: StoryCategory | string) => {
  return nodes.filter(node => {
    return nodeHasChannel(node, channel);
  });
};

export const nodeHasTag = (node: StoryObject, tag: StoryCategory | string) => {
  if (!node?.tags) {
    return false;
  }
  const tag_name = typeof tag === 'string' ? tag : tag.name;
  let has_tag = false;
  node?.tags?.forEach((c: StoryCategory) => {
    const cn = c.name ? c.name : c;
    if (tag_name === cn) has_tag = true;
  });
  return has_tag;
};

export const getNodesForTag = (nodes: StoryObject[], tag: StoryCategory | string) => {
  return nodes.filter(node => {
    return nodeHasTag(node, tag);
  });
};

export const getStocks = (Tickers: StoryCategory[]): string[] => {
  const tickers: string[] = [];
  if (Tickers && Tickers.length) {
    Tickers.forEach(Ticker => {
      tickers.push(Ticker.name);
    });
  }
  return tickers;
};

export const formatSymbols = (symbols: string | string[]): string | string[] => {
  let result: string | string[] = [];
  if (typeof symbols === 'string') {
    result = symbols.replace('/', '-');
  } else if (Array.isArray(symbols)) {
    result = symbols.map(symbol => symbol.replace('/', '-'));
  }
  return result;
};

export const getNodeUrl = (node: { id: string | number; url?: string }) =>
  node.url && node.url !== 'undefined' ? node.url : `https://www.benzinga.com/node/${node.id}`;

export const combineStoryObjectArrays = (
  firstArray: StoryObject[],
  secondArray: StoryObject[],
  shouldReverse?: boolean,
): StoryObject[] => {
  if (!Array.isArray(firstArray) || !Array.isArray(secondArray)) return [];
  const concattedArray = firstArray.concat(secondArray);
  const sortedArray = concattedArray.sort((storyA, storyB) => storyA.nodeId - storyB.nodeId).reverse();

  if (shouldReverse) {
    sortedArray.reverse();
  }

  return sortedArray;
};
